export const HABITAT_RULE_PREFIX = 'habitat';
export var Habitat;
(function (Habitat) {
    Habitat["View"] = "habitat:view";
    Habitat["ViewCount"] = "habitat:view-count";
    Habitat["UploadMedia"] = "habitat:upload-media";
    Habitat["EditText"] = "habitat:edit-text";
    Habitat["EditMedia"] = "habitat:edit-media";
    Habitat["EditCards"] = "habitat:edit-cards";
    Habitat["EditQuiz"] = "habitat:edit-quiz";
    Habitat["EditAlbum"] = "habitat:edit-album";
    Habitat["EditAlbumMedia"] = "habitat:edit-album-media";
    Habitat["EditAlbumMediaDownload"] = "habitat:edit-album-media-download";
    Habitat["EditAlbumMediaHide"] = "habitat:edit-album-media-hide";
    Habitat["EditStream"] = "habitat:edit-stream";
    Habitat["EditStreamPower"] = "habitat:edit-stream-power";
    Habitat["EditStreamEmoji"] = "habitat:edit-stream-emoji";
    Habitat["EditStreamOverlay"] = "habitat:edit-stream-overlay";
    Habitat["EditStreamConfiguration"] = "habitat:edit-stream-configuration";
    Habitat["EditStreamConfigurationControls"] = "habitat:edit-stream-configuration-controls";
    Habitat["EditStreamConfigurationHabitatMetadata"] = "habitat:edit-stream-configuration-habitat-metadata";
    Habitat["EditStreamOfflineImage"] = "habitat:edit-stream-offline-image";
    Habitat["EditStreamDefaultCamera"] = "habitat:edit-stream-default-camera";
    Habitat["EditSchedule"] = "habitat:edit-schedule";
    Habitat["Broadcast"] = "habitat:broadcast";
})(Habitat || (Habitat = {}));
